const TrackingHeader = ({ rastreioRef }) => (
  <div className="row border-top pt-4">
    <div className="col-12">
      <h1 className="mt-2 mb-0 fw-light" ref={rastreioRef}>
        Dados de envio
      </h1>
      <p className="text-secondary fs-5">
        Informe o código de rastreio e comprovante de envio do pedido
      </p>
    </div>
  </div>
);

export default TrackingHeader;
